import moment from 'moment';

export const getStateTree = state => state;
export const hasDatePassed = date => moment().isAfter(moment(date).startOf('day'));



// WEBPACK FOOTER //
// ./src/selectors/utils.js